import { ClientSecret } from "api/account/client";
import React from "react";
import colours from "styles/colours";
import {
  getNumberOfDaysBetweenDates,
  MAX_DAYS_IN_ONE_MONTH,
} from "utils/dateHelpers";

import {
  StatusContainer,
  StatusDot,
  StatusLabelContainer,
  StatusTooltip,
} from "./style";

type Props = {
  secret: ClientSecret;
};

const SecretStatus: React.FC<Props> = ({ secret: { expiryTime } }) => {
  const expiryDate = new Date(expiryTime);
  const now = new Date();
  const daysBeforeExpiry = getNumberOfDaysBetweenDates(now, expiryDate);
  if (daysBeforeExpiry > MAX_DAYS_IN_ONE_MONTH) {
    return (
      <div>
        <StatusLabelContainer colour={colours.validGreen}>
          <StatusDot colour={colours.validGreen} />
          <span>Valid</span>
        </StatusLabelContainer>
      </div>
    );
  }

  const secretExpired = expiryDate < now;
  const tooltipText = secretExpired
    ? "Request a new secret and replace it in your client to resume receiving IRIS messages."
    : "Request a new secret before this secret expires and replace it " +
      "in your client to ensure you continue receiving IRIS messages.";

  const statusDotColour = secretExpired
    ? colours.elexonExpiredRed
    : colours.darkOrange;

  return (
    <StatusContainer secretExpired={secretExpired} role="button" tabIndex={0}>
      <StatusLabelContainer colour={statusDotColour}>
        <StatusDot colour={statusDotColour} />
        <p>{secretExpired ? "Expired" : "Expiring soon"}</p>
      </StatusLabelContainer>
      <StatusTooltip id="secret-status-tooltip-text">
        {tooltipText}
      </StatusTooltip>
    </StatusContainer>
  );
};

export default SecretStatus;
